import { gql } from '@apollo/client';

export const GET_PROJECT_REPORTS_AND_RECIPIENTS = gql`
  query GetProjectReportsAndRecipients($id: ID!) {
    baseProject(id: $id) {
      id
      name
      alias
      customerReports {
        id
        projectId
        title
        periodStart
        periodEnd
        status
        template
        externalReportLink
        rejectionReason
        pdfReportPath
        lastUpdate
      }
      reportRecipients {
        id
        projectId
        firstName
        lastName
        email
        type
      }
    }
  }
`;
